import React, { Fragment } from 'react';
import { Button, Icon, Table, Header, Segment, Popup, Loader, Grid } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Redirect } from 'react-router';
import { IconHeader, FiltersOnStyle, HeaderCursor } from '../Professor/ProfessorInputGrades/css';
import HRFilters from './HRFilters';
import SelectOrgUnit from './SelectOrgUnit';
import {ExportReactCSV} from "../util/ExportCSV";
import SearchTableData from "../util/SearchTableData";
import PaginationFront from "../util/PaginationFront";
import ReactExport from 'react-data-export';

const NoDataMessage = () => <p>Nema zaposlenika.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class EmployeeListAssociate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employeeTypes: [],
            data: [],
            showProfile: false,
            loading: true,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
            excelData: [],
        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getEmployees = this.getEmployees.bind(this);
        this.getPersonAndEmployee = this.getPersonAndEmployee.bind(this);
        this.getResults = this.getResults.bind(this);
    }
    componentDidMount() {
        this.getEmployees();
        window.localStorage.removeItem('main');
        window.localStorage.removeItem('employee');
        window.localStorage.removeItem('person');
        window.localStorage.removeItem('academicStaff');
    }
    getEmployees() {
        const { employeeTypes } = this.state;
        let obj = {
            employeeTypeId: '',
            associateStaff: true
        };
        if (localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:') {
            obj = {
                organizationalUnitId: parseInt(localStorage.getItem('orgUnitId')),
                employeeTypeId: '',
                associateStaff: true
            };
        }
        axios.post('employees/by-organizational-unit/', { ...obj })
            .then(res => {
                this.setState({
                    loading: false,
                    data: res.data.map(el => ({
                        ...el
                    }))

                });
                const excelData = this.state.data.map(el => ([
                    { value: el.employeeLastName},
                    { value: el.employeeFirstName },
                    { value: String(el.employeeJmbg)},
                    { value: el.employeeTypeName},
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch (all) employees');
            });
    }
    getPersonAndEmployee(jmbg, main) {
        localStorage.setItem('main', main);
        if (localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:') {
            localStorage.setItem('main', 'false');
        }
        let obj = {
            jmbg
        };
        axios.post('hr/get-person-by-jmbg/', { ...obj })
            .then(res => {
                localStorage.setItem('person', JSON.stringify(res.data[0]));
                axios.post('hr/get-employee-by-jmbg/', { ...obj })
                    .then(res => {
                        localStorage.setItem('employee', JSON.stringify(res.data[0]));
                        res.data[0].associateStaff ? localStorage.setItem('associate', 'true') : localStorage.setItem('associate', 'false');
                        if (res.data[0].employeeType._key === 'nastavno osoblje') localStorage.setItem('academicStaff', 'true');
                        if (res.data[0].employeeType._key === 'nenastavno osoblje') localStorage.setItem('academicStaff', 'false');
                        this.setState({ showProfile: true });
                    });
            });
    }
    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {

        const headersForExport = [
            { label: 'Prezime', key: 'employeeLastName' },
            { label: 'Ime', key: 'employeeFirstName' },
            { label: 'JMBG', key: 'employeeJmbg' },
            { label: 'Tip osoblja', key: 'employeeTypeName' }
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 200 } },
                    { title: 'JMBG', width: { wpx: 150 }},
                    { title: 'Tip osoblja', width: { wpx: 250 }}
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        if (this.state.showProfile) return <Redirect push to={{ pathname: '/angažovano-osoblje/informacije-o-zaposleniku' }} />;
        return (
            <div>
                <h1> Angažovano osoblje </h1>
                <Segment.Group raised>
                    {localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' &&
                    <Segment>
                        <h3>Lista zaposlenika</h3>
                    </Segment>}
                    {localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' && <Segment><SelectOrgUnit getEmployees={this.getEmployees} /></Segment>}
                    {(localStorage.getItem('orgUnitId') || localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Fragment>
                        {localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' &&  <Segment clearing>
                            <Header as="h3">
                               Lista zaposlenika
                            </Header>
                        </Segment>}

                        {this.state.loading ? <Segment>
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        </Segment>
                            : <Segment>
                                {currentPosts.length ?
                                    <div>
                                        <Table celled selectable compact >
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell colSpan={16} >
                                                        <Grid columns={2} stackable>

                                                            <Grid.Column width={14}>
                                                                <SearchTableData profMozilla data={this.getDataToRender()} getResults={this.getResults} filterItem={['employeeLastName', 'employeeFirstName', 'employeeJmbg', 'employeeTypeName']} />
                                                            </Grid.Column>
                                                            <Grid.Column width={2} textAlign={'center'}>
                                                                <ExcelFile filename="Spisak angažovanog osoblja" element={<Popup
                                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                        <Button.Content visible>
                                                                            Excel
                                                                        </Button.Content>
                                                                    </Button>}
                                                                    content="Preuzmi spisak u Excel-u"
                                                                    hideOnScroll
                                                                    position="top center"
                                                                />}>
                                                                    <ExcelSheet dataSet={multiDataSet} name="Zaposlenici" />
                                                                </ExcelFile>
                                                                {/*<ExportReactCSV  icon color="green" disabled={this.getDataToRender().length === 0} fluid csvData={this.getDataToRender()} headers={headersForExport} fileName="Spisak angažovanog osoblja" />*/}
                                                            </Grid.Column>
                                                        </Grid>

                                        {/*                */}
                                        {/*<span> {this.state.data && <ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} floated="right" fileName="Spisak angažovanog osoblja" />}*/}
                                        {/*    <SearchTableData data={this.state.data} getResults={this.getResults} filterItem={['employeeLastName', 'employeeFirstName', 'employeeJmbg', 'employeeTypeName']} />*/}
                                        {/*</span>*/}

                                                    </Table.HeaderCell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.HeaderCell>R. br.</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3}>Prezime</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3}>Ime</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3}>JMBG</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3}>Tip osoblja</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3}/>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {currentPosts.map((el, index) =>
                                                    (<Popup
                                                        trigger={<Table.Row
                                                            key={index}
                                                            style={HeaderCursor}
                                                            onClick={() => this.getPersonAndEmployee(el.employeeJmbg, el.main)}
                                                        >
                                                            <Table.Cell verticalAlign="middle">
                                                                {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                                                {el.employeeLastName}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                                                {el.employeeFirstName}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                                                {el.employeeJmbg}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                                                {el.employeeTypeName}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" textAlign="center" colSpan={3}>
                                                                <Button
                                                                    basic="true"
                                                                    color="blue"
                                                                    size="small"
                                                                    onClick={() => this.getPersonAndEmployee(el.employeeJmbg, el.main)}
                                                                > Detalji
                                                                </Button>
                                                            </Table.Cell>
                                                        </Table.Row>}
                                                        content="Prikaz detalja o zaposleniku"
                                                        hideOnScroll
                                                        position="left center"
                                                    />))}
                                            </Table.Body>
                                        </Table>
                                    </div>
                                    : <NoDataMessage />
                                }
                                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                            </Segment>}
                    </Fragment>}
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/EmployeeListAssociate.js